import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { ChickenTestDialogComponent } from './chicken-test-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class ChickenTestDialogService {
  constructor(private dialog: MatDialog) {}

  public open(
    testQuestion: string,
    affirmativeText: string,
    negativeText: string,
    maxViewWidth?: number,
    disclaimerText?: string,
    titleText?: string,
    richQuestionText?: boolean,
    testQuestionTwo?: string,
    isConfirmation?: boolean,
  ): Observable<boolean> {
    let dialogRef: MatDialogRef<ChickenTestDialogComponent>;
    dialogRef = this.dialog.open(ChickenTestDialogComponent, {
      data: {
        testQuestion: testQuestion,
        affirmativeText: affirmativeText,
        negativeText: negativeText,
        disclaimerText: disclaimerText,
        titleText: titleText,
        enableRichText: richQuestionText,
        testQuestionTwo: testQuestionTwo,
        isConfirmation: isConfirmation,
      },
      maxWidth: maxViewWidth + 'vw',
    });
    return dialogRef.afterClosed();
  }
}
